import React, { useEffect, useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import { Autocomplete, Box, Button, Chip, Stack, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import { assignTutor } from '../../redux/features/batchSlice';
import { Icon } from '@iconify/react/dist/iconify.js';
import GlobalDialog from '../../components/mui/Dialogue/GlobalDialog';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import WarningPopup from '../cro/myworkspace/CROleads/components/WarningPopup';

const AssignPopup = ({ tutorName, disabled, trainerID, subject_enrollment_id, subject }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [warning, setWarning] = useState(false);
  const { loading } = useSelector((state) => state.batch);

  const validationSchema = Yup.object().shape({
    paymentPerSession: Yup.string().required('Enter payment per session'),
    // sessionCount: Yup.string().required("Enter session count"),
    duration: Yup.string().required('Enter session duration'),
    noOfAttendance: Yup.string().required('Add no of attendance'),
    // preferences: Yup.array()
    //   .of(
    //     Yup.object().shape({
    //       week_day: Yup.array()
    //         .min(1, "Select day preference")
    //         .of(Yup.number().integer().min(0).max(6))
    //         .required("Day preference is required"),
    //     })
    //   )
    //   .required("Preferences are required"),
    // startTime: Yup.date().nullable().required("Start time is required"),
    // endTime: Yup.date().nullable().required("End time is required"),
  });

  const submitHandler = (values) => {
    const payload = {
      subject_enrollment_id: values.subject_enrollment_id,
      assignments: [
        {
          trainer_id: values.trainer_id,
          sessionCount: values.sessionCount,
          startTime: null,
          endTime: null,
          paymentPerSession: values.paymentPerSession,
          duration: values.duration,
          noOfAttendance: values.noOfAttendance,
          TPRemarks: values.TPRemarks,
          subject_enrollment_id: values.subject_enrollment_id,
        },
      ],
    };

    dispatch(assignTutor(payload)).then((res) => {
      if (res.payload.status === 'success') {
        enqueueSnackbar(res.payload.message, { variant: 'success' });
        navigate(-1);
        setOpen(false);
      } else {
        enqueueSnackbar(res.payload.message, { variant: 'error' });
      }
    });
  };

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: validationSchema,
    initialValues: {
      trainer_id: trainerID,
      sessionCount: null,
      startTime: null,
      endTime: null,
      paymentPerSession: '',
      duration: '',
      noOfAttendance: '',
      TPRemarks: '',
      subject_enrollment_id: subject_enrollment_id,
    },
    onSubmit: (values) => {
      setWarning(values);
    },
  });

  const weekdays = [
    { id: 0, day: 'Sunday' },
    { id: 1, day: 'Monday' },
    { id: 2, day: 'Tuesday' },
    { id: 3, day: 'Wednesday' },
    { id: 4, day: 'Thursday' },
    { id: 5, day: 'Friday' },
    { id: 6, day: 'Saturday' },
  ];

  return (
    <GlobalDialog
      title={'Assign Tutor'}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'sm'}
      closeButton={true}
      popupButton={
        <Button size="small" variant="contained" color="secondary" disabled={disabled} onClick={() => setOpen(true)}>
          <Icon icon={'mdi:tick-circle-outline'} width={18} height={18} />
          Select
        </Button>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <GlobalDialog
                  title={'Warning'}
                  content={<WarningPopup handleSubmit={submitHandler} values={warning} />}
                  setOpen={setWarning}
                  open={Boolean(warning)}
                  closeButton
                />
                <Stack direction={'column'} spacing={2}>
                  <Chip label={`Tutor : ${tutorName}`} size="medium" variant="contained" color="secondary" />
                  <Chip label={`Subject : ${subject}`} size="medium" variant="contained" color="secondary" />
                  {/* <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={weekdays}
                    getOptionLabel={(option) => option.day}
                    value={weekdays.filter((day) =>
                      formik.values.preferences[0].week_day.includes(day.id)
                    )}
                    onChange={(event, newValue) => {
                      formik.setFieldValue(
                        "preferences[0].week_day",
                        newValue.map((day) => day.id)
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Day Preference"
                        placeholder="Choose days"
                        error={
                          formik.touched.preferences?.[0]?.week_day &&
                          Boolean(formik.errors.preferences?.[0]?.week_day)
                        }
                        helperText={
                          formik.touched.preferences?.[0]?.week_day &&
                          formik.errors.preferences?.[0]?.week_day
                        }
                      />
                    )}
                  /> */}
                  {/* <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        label="Start Time"
                        value={formik.values.startTime}
                        onChange={(value) =>
                          formik.setFieldValue("startTime", value)
                        }
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error:
                              formik.touched.startTime &&
                              Boolean(formik.errors.startTime),
                            helperText:
                              formik.touched.startTime &&
                              formik.errors.startTime,
                          },
                        }}
                      />
                      <TimePicker
                        label="End Time"
                        value={formik.values.endTime}
                        onChange={(value) =>
                          formik.setFieldValue("endTime", value)
                        }
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error:
                              formik.touched.endTime &&
                              Boolean(formik.errors.endTime),
                            helperText:
                              formik.touched.endTime && formik.errors.endTime,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Stack> */}
                  {/* <TextField
                    name="sessionCount"
                    value={formik.values.sessionCount}
                    error={
                      formik.touched.sessionCount &&
                      Boolean(formik.errors.sessionCount)
                    }
                    helperText={formik.errors.sessionCount}
                    onChange={formik.handleChange}
                    fullWidth
                    size="medium"
                    label="Total Session"
                    placeholder="Enter session count"
                  /> */}
                  <TextField
                    name="paymentPerSession"
                    value={formik.values.paymentPerSession}
                    error={formik.touched.paymentPerSession && Boolean(formik.errors.paymentPerSession)}
                    helperText={formik.errors.paymentPerSession}
                    onChange={formik.handleChange}
                    fullWidth
                    size="medium"
                    label="Payment"
                    placeholder="Enter tutor payment per session"
                  />
                  <TextField
                    name="duration"
                    size="medium"
                    value={formik.values.duration}
                    error={formik.touched.duration && Boolean(formik.errors.duration)}
                    helperText={formik.errors.duration}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Duration"
                    placeholder="Enter session duration in minutes"
                  />
                  <TextField
                    name="noOfAttendance"
                    size="medium"
                    value={formik.values.noOfAttendance}
                    error={formik.touched.noOfAttendance && Boolean(formik.errors.noOfAttendance)}
                    helperText={formik.errors.noOfAttendance}
                    onChange={formik.handleChange}
                    type="number"
                    fullWidth
                    label="No Of Attendance"
                    placeholder="Enter maximum number of attendance per day"
                  />
                  <TextField
                    name="TPRemarks"
                    size="medium"
                    value={formik.values.TPRemarks}
                    error={formik.touched.TPRemarks && Boolean(formik.errors.TPRemarks)}
                    helperText={formik.errors.TPRemarks}
                    onChange={formik.handleChange}
                    fullWidth
                    multiline
                    rows={2}
                    label="TP Remarks"
                    placeholder="Enter TP Remarks"
                  />
                </Stack>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
                  <Stack direction={'row'} spacing={1}>
                    <Button size="small" variant="outlined" color="secondary" onClick={() => setOpen(false)}>
                      Cancel
                    </Button>
                    <Button disabled={loading} variant="contained" color="secondary" size="small" type="submit">
                      {loading ? 'Please wait...' : 'Save'}
                    </Button>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default AssignPopup;
